import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ManaulShopperPage } from './manaul-shopper';

@NgModule({
  declarations: [
    ManaulShopperPage,
  ],
  imports: [
    IonicPageModule.forChild(ManaulShopperPage),
    TranslateModule.forChild()
  ],
})
export class ManaulShopperPageModule {}



// WEBPACK FOOTER //
// ./src/pages/manaul-shopper/manaul-shopper.module.ts